import { useCallback, useState } from "react";
import { Accordion, Card } from "react-bootstrap";

export default function TaxiFaq({faqData, title = "Frequently Asked Questions"}) {
  const [activeKey, setActiveKey] = useState("0");

  const handleToggle = useCallback(
    (key) => {setActiveKey((prevKey) => (prevKey === key ? null : key));
    },[]);
    
    const firstWord = title.split(" ")[0];
const rest = title.substring(title.indexOf(" ") + 1);

  return (
    <section className="carpool-faq">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="heading center-heading">
              {firstWord}
              <span className="gradiant-color"> {rest}</span>
            </h4>
            <Accordion activeKey={activeKey} className="faq-accord">
              {faqData?.map(({ id, question, answer }) => (
                <Card key={id} className={activeKey === id ? "active" : ""}>
                  <Card.Header>
                    <Accordion.Item eventKey={id}>
                      <Accordion.Header as="h4" onClick={() => handleToggle(id)}>
                        <label>{question}</label>
                        <span>{activeKey === id ? "−" : "+"}</span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>{answer}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card.Header>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
